import dtp1 from '@/assets/img/icons/dtp1.png'
import dtp2 from '@/assets/img/icons/dtp2.png'
import clock from '@/assets/img/icons/clock.png'
import calendar from '@/assets/img/icons/calendar.png'
import list from '@/assets/img/icons/list.png'
import dayjs from 'dayjs'

type BalloonsDtp = {
  accidentDate: string
  address: string
  accidentType: string
  dead: number
  id: number
  injured: number
  number: string
  typeId: number
}

type BalloonsCluster = {
  items: {
    id: number
    number: number
    accidentDate: string
    accidentType: string
    dead: number
    injured: number
  }[]
  clusterId: number
  typeId: number
  road: string
}

export const balloonDtp = (
  isError: boolean,
  isLoading: boolean,
  unitData: BalloonsDtp
): string => {
  if (!unitData)
    return `<div style="width: 320px"><p style='position: absolute; top: 34%; left: 30%; display: ${isLoading ? 'block' : 'none'}'>Загрузка данных...</p></div>`
  const rawDate = unitData?.accidentDate
  const date = dayjs(rawDate).format('DD.MM.YYYY')
  const time = dayjs(rawDate).format('HH.mm')

  return `<div style="width: 320px">
          <style>.ymaps-2-1-79-balloon__tail {left: 45px !important}</style>
           <div style='${isLoading ? 'filter: blur(3px);' : 'filter: unset;'}; ${isError ? 'display: none' : 'display: block;'};'>
             <a class='balloon-link' href=/devices/${unitData?.id}>${unitData?.number}</a>
             <p>${unitData?.address}</p>
             <p style="display: flex; gap: 8px; align-items: center;"><img src="${list}" height="20"/> ${unitData?.accidentType}</p>
             <div style="display: flex; gap: 15px; align-items: center; white-space: nowrap">
             <div style="display: flex; gap: 3px; align-items: center">
                 <img src="${dtp1}" height="25"/>
                 <span style="color: #0072bc">${unitData?.dead || 0}</span>
            </div>
            <div style="display: flex; gap: 3px; align-items: center">
                 <img src="${dtp2}" height="25"/>
                 <span style="color: #0072bc">${unitData?.injured || 0}</span>
            </div>
            <div style="display: flex; gap: 3px; align-items: center">
                 <img src="${calendar}" height="15"/>
                 <span style="color: #0072bc">${date || 0}</span>
            </div>
            <div style="display: flex; gap: 3px; align-items: center">
                 <img src="${clock}" height="15"/>
                 <span style="color: #0072bc">${time || 0}</span>
            </div>
</div>
           </div></div>`
}

export const balloonCluster = (
  isError: boolean,
  isLoading: boolean,
  unitData: BalloonsCluster
): string => {
  if (!unitData)
    return `<div style="width: 400px"><p style='position: absolute; top: 34%; left: 30%; display: ${isLoading ? 'block' : 'none'}'>Загрузка данных...</p></div>`
  const items = unitData?.items.map((item) => {
    const rawDate = item?.accidentDate
    const date = dayjs(rawDate).format('DD.MM.YYYY')
    const time = dayjs(rawDate).format('HH.mm')

    return `<p style="display: flex; gap: 8px; align-items: center; margin-bottom: 0"><img src="${list}" height="20"/> ${item?.accidentType}</p><div style="display: flex; gap: 10px; align-items: center; white-space: nowrap">
<div style="display: flex; gap: 3px; align-items: center"><a class='balloon-link' href=/devices/${item.id}>${item.number}</a></div>
<div style="display: flex; gap: 2px; align-items: center">
                 <img src="${dtp1}" height="25"/>
                 <span style="color: #0072bc">${item?.dead || 0}</span>
            </div>
            <div style="display: flex; gap: 2px; align-items: center">
                 <img src="${dtp2}" height="25"/>
                 <span style="color: #0072bc">${item?.injured || 0}</span>
            </div>
<div style="display: flex; gap: 2px; align-items: center">
                 <img src="${calendar}" height="15"/>
                 <span style="color: #0072bc">${date || 0}</span>
            </div>
            <div style="display: flex; gap: 2px; align-items: center">
                 <img src="${clock}" height="15"/>
                 <span style="color: #0072bc">${time || 0}</span>
            </div>
</div>`
  })
  const title =
    unitData?.typeId === 16
      ? 'Предочаг концентрации ДТП'
      : 'Место концентрации ДТП'
  return `<div style="width: 320px">
          <style>.ymaps-2-1-79-balloon__tail {left: 45px !important}</style>
           <div style='${isLoading ? 'filter: blur(3px);' : 'filter: unset;'}; ${isError ? 'display: none' : 'display: block;'};'>
           <p>${title}</p>
             <p>${unitData?.road}</p>
             <div>${items.join('')}</div>
</div>
           </div></div>`
}
